import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Globe, Check } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { LANGS } from "../i18n/translations";

export const LanguageSelector = ({ compact = false }) => {
  const { lang, setLang } = useLang();
  const [open, setOpen] = useState(false);
  const current = LANGS.find((l) => l.code === lang);

  return (
    <div className="relative" data-testid="language-selector">
      <button
        onClick={() => setOpen((o) => !o)}
        data-testid="language-toggle"
        className="flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-3 py-2 text-sm font-medium text-white/80 backdrop-blur-md transition-transform hover:scale-105 active:scale-95"
      >
        <Globe size={16} className="text-[#f093fb]" />
        <span>{current?.flag}</span>
        {!compact && <span>{current?.code.toUpperCase()}</span>}
      </button>
      <AnimatePresence>
        {open && (
          <>
            <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
            <motion.div
              initial={{ opacity: 0, y: -8, scale: 0.95 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: -8, scale: 0.95 }}
              transition={{ duration: 0.15 }}
              className="absolute right-0 z-50 mt-2 w-44 overflow-hidden rounded-2xl border border-white/10 bg-[#16162a] shadow-2xl"
            >
              {LANGS.map((l) => (
                <button
                  key={l.code}
                  data-testid={`language-option-${l.code}`}
                  onClick={() => {
                    setLang(l.code);
                    setOpen(false);
                  }}
                  className="flex w-full items-center justify-between px-4 py-3 text-left text-sm text-white/85 transition-colors hover:bg-white/10"
                >
                  <span className="flex items-center gap-2">
                    <span className="text-base">{l.flag}</span>
                    {l.label}
                  </span>
                  {l.code === lang && <Check size={15} className="text-[#38ef7d]" />}
                </button>
              ))}
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </div>
  );
};
